import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";

// the translations
const resources = {
  en: {
    translation: en,
  },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  debug: true,
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
